export const HouseholdPortfolioChangeReasons = {
  attach: 'attach',
  detach: 'detach',
  update: 'update',
} as const;

export type HouseholdPortfolioChangeReason =
  (typeof HouseholdPortfolioChangeReasons)[keyof typeof HouseholdPortfolioChangeReasons];

export type HouseholdPortfolioAttachMutationReason =
  | typeof HouseholdPortfolioChangeReasons.attach
  | typeof HouseholdPortfolioChangeReasons.update;

export const shouldPollAfterHouseholdPortfolioChange = (
  reason: HouseholdPortfolioChangeReason,
): boolean =>
  reason === HouseholdPortfolioChangeReasons.attach ||
  reason === HouseholdPortfolioChangeReasons.update;

type HouseholdAttachReportLike = {
  modelPortfolio?: { id?: string | null } | null;
} | null;

export const isHouseholdAttachReportForExpectedProduct = (
  report: HouseholdAttachReportLike,
  expectedFinancialProductId: string | null | undefined,
): boolean => {
  if (!expectedFinancialProductId) return Boolean(report);
  if (!report?.modelPortfolio?.id) return false;

  return report.modelPortfolio.id === expectedFinancialProductId;
};
